export default __webpack_public_path__ + "static/media/setdiggov.4a3405c9.svg";